export const toggle = () => ({
  type: "TOGGLE_AUDIO"
});
export const enable = () => ({
  type: "ENABLE_AUDIO"
});
export const disable = () => ({
  type: "DISABLE_AUDIO"
});
